export const encodeQueryData = (params: object): string => (
  Object
    .entries(params ?? {})
    .map(([key, value]) => (`${encodeURIComponent(key)}=${encodeURIComponent(value)}`))
    .join('&')
);
